{
  "selectCompanyStep": {
    "title": "Erzählen Sie uns ein wenig mehr",
    "description": "Helfen Sie uns, Ihre Chirpee-Erfahrung so angenehm wie möglich zu gestalten",
    "companyInput": {
      "label": "Wie heißt Ihr Unternehmen?",
      "placeholder": "Unternehmensnamen eingeben"
    },
    "industryInput": {
      "label": "Branche des Unternehmens",
      "placeholder": "Branche auswählen"
    },
    "dataRegion": {
      "label": "Datenregion",
      "placeholder": "Datenregion auswählen",
      "tooltip": "Dies legt fest, wo Ihre Daten gespeichert werden. Es kann nach der Registrierung nicht mehr geändert werden.",
      "us": "Vereinigte Staaten",
      "eu": "Europäische Union"
    },
    "nextStepButton": "Nächster Schritt",
    "industries": {
      "technology": "Technologie",
      "professionalServices": "Professionelle Dienstleistungen",
      "financialServices": "Finanzdienstleistungen",
      "consulting": "Beratung",
      "softwareDevelopment": "Softwareentwicklung",
      "digitalMarketing": "Digitales Marketing",
      "mediaAndCommunications": "Medien und Kommunikation",
      "eCommerce": "E-Commerce",
      "healthTech": "Gesundheitstechnologie"
    }
  },
  "selectLanguageStep": {
    "title": "Wählen Sie die Arbeitssprachen",
    "description": "Wählen Sie die Sprachen aus, die an Ihrem Arbeitsplatz unterstützt werden. Sie können sie später in den Einstellungen bearbeiten"
  }
}
